module.exports = __webpack_public_path__ + "static/media/book-cover.bc75b5ba.jpg";